export const changeNounForNumeral = (number, variations) => {
    const pluralRules = new Intl.PluralRules('pl-PL');
    return variations[pluralRules.select(number)];
};

export const changeMonthForNumeral = votes => {
    const variations = {
        one: 'miesiąc',
        few: 'miesiące',
        many: 'miesięcy',
    };
    return changeNounForNumeral(votes, variations);
};
